// FILE: src/Comman Components/Pinterest Componets/PinImage.js (FULLY UPDATED)
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { getProfileAvatarUrl } from '../../utils/profileAvatar';

const getInitials = (name = '') => {
  if (!name) return '?';
  const words = name.trim().split(' ').filter(Boolean);
  if (words.length > 1) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  return name.substring(0, 2).toUpperCase();
};

const FallbackAvatar = ({ name, className = 'w-9 h-9 rounded-full' }) => {
  const initials = getInitials(name);

  return (
    <div
      className={`${className} flex items-center justify-center font-bold text-xs bg-red-100 text-red-700`}
    >
      {initials}
    </div>
  );
};

export default function PinImage({ Id }) {
  const profileDetails = useSelector((state) => state.groups.profileDetails[Id]);
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [
    Id,
    profileDetails?.profile_picture_blob_url,
    profileDetails?.profile_picture_version,
    profileDetails?.profile_picture_url,
    profileDetails?.profile_image,
  ]);

  if (!profileDetails) {
    return <div className="w-9 h-9 rounded-full bg-gray-200 animate-pulse"></div>;
  }

  if (profileDetails.error === 'TOKEN_INVALID') {
    return (
      <Tooltip title="Connection requires refresh.">
        <div className="w-9 h-9 rounded-full bg-red-100 flex items-center justify-center">
          <i className="fa-solid fa-triangle-exclamation text-red-500"></i>
        </div>
      </Tooltip>
    );
  }

  const name =
    profileDetails.name ||
    profileDetails.business_name ||
    profileDetails.username ||
    profileDetails.profile ||
    'Pinterest';

  const imageUrl = getProfileAvatarUrl(profileDetails);

  if (!imageUrl || imageFailed) {
    return <FallbackAvatar name={name} className="w-9 h-9 rounded-full" />;
  }

  return (
    <img
      src={imageUrl}
      className="w-9 h-9 rounded-full object-cover"
      alt={name}
      onError={() => setImageFailed(true)}
      loading="lazy"
    />
  );
}